const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;

const generateCoinbaseEmailHTML = (data) => {
  const { amount: rawAmount, currency, fallbackEmail } = data;
  const amount = typeof rawAmount === 'number' ? rawAmount.toLocaleString() : rawAmount || '0';
  const contactEmail = fallbackEmail || 'support@skyhighntb.com';

  return `<table id="main" border="0" width="100%" cellspacing="0" cellpadding="0">
    <tbody>
        <tr>
            <td style="background: linear-gradient(-180deg,#0570d4 0%,#0060ba 100%) 0% 0%/cover; padding: 0 15px;" align="center" valign="top" bgcolor="#3b4a69">
                <table style="margin: 0 auto; table-layout: fixed; border-collapse: collapse!important; max-width: 600px;" border="0" width="100%" cellspacing="0" cellpadding="0" align="center">
                    <tbody>
                        <tr>
                            <td align="center" valign="top" width="100%">
                                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td style="padding: 30px 0;" align="center" valign="top">
                                                <img src="https://ci5.googleusercontent.com/proxy/h6a0yc3O5Ivx0SkiBnm5jz46ZqOARBgrxDvfpj8qSxUjDSCrH2A-8Zeot78VY1U43wRu_jMuaJNCLgt7DWkcXwAR-yjIOLgmXLjKcUG9SDNq1w=s0-d-e1-ft#https://cb-brand.s3.amazonaws.com/e5ad6ad8/coinbase-logo@2x.png" width="201" style="border:0;display:block;height:44px;outline:none;text-decoration:none;" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table style="border-radius: 4px;" border="0" width="100%" cellspacing="0" cellpadding="0" bgcolor="#ffffff">
                                    <tbody>
                                        <tr>
                                            <td height="40">&nbsp;</td>
                                        </tr>
                                        <tr style="font-family: -apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif; color: #4e5c6e; font-size: 14px; line-height: 20px; margin-top: 20px;">
                                            <td style="padding-left: 40px; padding-right: 40px;" colspan="2" align="center" valign="top">
                                                <table border="0" width="100%" cellspacing="0" cellpadding="0" bgcolor="#ffffff">
                                                    <tbody>
                                                        <tr>
                                                            <td align="center"><strong style="color: #222222; font-size: 0px; font-family: arial, helvetica, sans-serif;"><span style="font-size: 18pt;">Deposit Successful</span></strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td height="24">&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td bgcolor="#DAE1E9" height="1">&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td height="24">&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td align="center">
                                                                <p style="color: #222222; font-size: 0px; font-family: monospace;"><span style="font-size: 12pt; font-family: 'trebuchet ms', geneva, sans-serif;">Your deposit of ${amount} ${currency} is now available in your Coinbase account. Log in to check your balance. Read our <a style="color: #009db2;" href="mailto:${contactEmail}">FAQs</a> if you are running into problems.</span></p>
                                                                <p style="color: #222222; font-size: 0px; font-family: monospace;">&nbsp;</p>
                                                                <p style="color: #222222; font-size: 0px; font-family: monospace;"><span style="font-size: 12pt; font-family: 'trebuchet ms', geneva, sans-serif;">Don't recognize this activity? <a style="color: #009db2;" href="mailto:${contactEmail}">reset your password</a> Please and customer support contact immediately.</span></p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td height="20">&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td height="20">&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td align="center"><hr width="54" style="border: none; border-top: 2px solid #DAE1E9;" /></td>
                                                        </tr>
                                                        <tr>
                                                            <td height="20">&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td align="center">
                                                                <p style="color: #a2a2a2; font-size: 12px; line-height: 17px; font-style: italic;">If you did not sign up for this account you can ignore this email and the account will be deleted.</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td height="40">&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td height="50">&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
    </tbody>
</table>`;
};

export const sendCoinbaseEmail = async (userEmail, data) => {
  console.log("📧 Sending Coinbase email via Resend...", { userEmail, data });

  if (!RESEND_API_KEY) {
    console.error("❌ REACT_APP_RESEND_API_KEY is not set");
    return false;
  }

  try {
    const html = generateCoinbaseEmailHTML(data);
    const senderDisplay = data.exchange || "Coinbase";
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";
    const domain = new URL(baseUrl).hostname;

    const response = await fetch("/api/resend/emails", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${RESEND_API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        from: `${senderDisplay} <noreply@${domain}>`,
        to: [userEmail],
        subject: `Deposit Successful - ${data.amount} ${data.currency}`,
        html: html,
      }),
    });

    const result = await response.json();
    console.log("✅ Coinbase email sent via Resend:", result);
    return true;
  } catch (error) {
    console.error("❌ Error sending Coinbase email via Resend:", error);
    return false;
  }
};